import React from 'react';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PassOrderPageData } from '../../../api';
import { SubscriptionCard } from './SubscriptionCard';

type SubscriptionsSectionProps = {
  passOrderPages: PassOrderPageData[];
};

export const SubscriptionsSection = ({ passOrderPages }: SubscriptionsSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (!passOrderPages.length) {
    return null;
  }

  return (
    <Grid container flexDirection="column" mt={isSmallScreen ? 4 : 8} mb={isSmallScreen ? 6 : 10}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 600,
          marginBottom: isSmallScreen ? 2 : 3,
          textAlign: isSmallScreen ? 'center' : 'start',
        }}>
        {t('storefront.ourSubscriptions')}
      </Typography>
      <Grid
        container
        flexDirection="column"
        sx={{
          gap: 1.5,
          width: isSmallScreen ? '100%' : '50%',
        }}>
        {passOrderPages.map((passOrderPage) => (
          <SubscriptionCard key={passOrderPage.id} passOrderPage={passOrderPage} />
        ))}
      </Grid>
    </Grid>
  );
};
